import React from 'react';
import PropTypes from 'prop-types';
import Countdown from 'react-countdown-now';
import HtmlToReact from 'html-to-react';
import ExternalButton from 'components/ExternalButton';
import { padNumber, fromIso9075DateString } from 'utils/functions';
import { quillSanitize } from 'utils/quill/functions';
import './CommunityMessage.css';

export const buttonType = 'button';
export const timerType = 'timer';

function CommunityMessage({ previous, current, large, preview }) {
  const showPrevious = previous && (!current || current.id !== previous.id);
  return (
    <div
      className={`community-message ${large
        ? 'community-message-large'
        : ''}`.trim()}
    >
      {showPrevious && (
        <div key={previous.id} className="element out">
          {createMessage(previous, preview)}
        </div>
      )}
      {current && (
        <div key={current.id} className={`element${showPrevious ? ' in' : ''}`}>
          {createMessage(current, preview)}
        </div>
      )}
    </div>
  );
}

function createMessage(message, preview = false) {
  let messageHtml = quillSanitize(message.message);
  messageHtml = messageHtml.replace(
    /%\[([A-Za-z0-9_-]+)\]%/g,
    '<span data-key="$1"></span>'
  );

  let component = parser.parseWithInstructions(
    messageHtml,
    isValidNode,
    processingInstructions(message, preview)
  );

  return component;
}

const timerRenderer = ({ hours, minutes, seconds }) => {
  return (
    <span>
      {padNumber(hours)}:{padNumber(minutes)}:{padNumber(seconds)}
    </span>
  );
};

const mapping = {
  timer: function(message, properties, attribs, id, preview) {
    return (
      message.end && (
        <span key={id} className="time">
          <Countdown
            date={fromIso9075DateString(message.end)}
            renderer={timerRenderer}
          />
        </span>
      )
    );
  },
  button: function(message, properties, attribs, id, preview) {
    let { link, style, text } = properties || {};
    if ('data-link' in attribs) {
      link = attribs['data-link'];
    }
    if ('data-style' in attribs) {
      style = attribs['data-style'];
    }
    if ('data-text' in attribs) {
      text = attribs['data-text'];
    }
    return (
      <ExternalButton
        key={id}
        to={link}
        text={text}
        buttonStyle={style}
        preview={preview}
      />
    );
  }
};

const parser = new HtmlToReact.Parser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const isValidNode = function() {
  return true;
};
const processingInstructions = (message, preview) => [
  {
    shouldProcessNode: function(node) {
      return node.attribs && node.attribs['data-key'];
    },
    processNode: function(node, children, index) {
      let key = node.attribs['data-key'];
      if (!(key in mapping)) {
        return null;
      }
      return mapping[key](
        message,
        message.properties ? message.properties[key] : undefined,
        node.attribs,
        key + index,
        preview
      );
    }
  },
  {
    // Process anything else with default
    shouldProcessNode: function(node) {
      return true;
    },
    processNode: processNodeDefinitions.processDefaultNode
  }
];

CommunityMessage.propTypes = {
  previous: PropTypes.object,
  current: PropTypes.object,
  large: PropTypes.bool,
  preview: PropTypes.bool
};

export default CommunityMessage;



// WEBPACK FOOTER //
// ./src/components/CommunityMessage/index.js